(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vindicta-engraving-entry"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mount=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const variants=JSON.parse(root.querySelector('[data-engraving-variants]').textContent),link=root.querySelector('a');
  const selected=()=>{const form=document.getElementById(root.dataset.formId);const id=(form?new FormData(form).get('id'):null)||root.dataset.selectedId||new URL(location.href).searchParams.get('variant');return variants.find(v=>String(v.id)===String(id))||variants[0];};
  const baseVariant=v=>variants.find(base=>!base.sku.startsWith('VGR-')&&base.option1===v.option1)||variants[0];
  const update=()=>{const base=baseVariant(selected()),url=new URL(root.dataset.productUrl,location.origin);url.searchParams.set('view','personnaliser');url.searchParams.set('variant',String(base.id));root.querySelector('[data-engraving-ready]').hidden=!base.available;root.querySelector('[data-engraving-unavailable]').hidden=base.available;if(base.available){link.href=url.href;link.removeAttribute('aria-disabled');}else{link.removeAttribute('href');link.setAttribute('aria-disabled','true');}return base.available;};
  link.addEventListener('click',event=>{if(!update()){event.preventDefault();event.stopImmediatePropagation();}},true);document.addEventListener('variant:change',update);update();
  const current=new URL(location.href),specified=variants.find(v=>String(v.id)===current.searchParams.get('variant'));
  if(specified&&specified.sku.startsWith('VGR-')){current.searchParams.set('variant',String(baseVariant(specified).id));location.replace(current.href);}
 };
 document.querySelectorAll('[data-engraving-entry]').forEach(mount);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-engraving-entry]').forEach(mount));
 document.addEventListener('product:rerender',()=>document.querySelectorAll('[data-engraving-entry]').forEach(mount));
})();
  } catch(e) { console.error(e); }
})();

})();
